import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CheckIcon from '../assets/icons/check_icon';
import config from '../config';
import AddCustomerModal from './AddCustomer';

import { toast } from 'react-toastify';
import AddCustomerFormModal from './AddCustomerFormModel';
import { useNavigate, useParams } from 'react-router-dom';

const AddProductModal = ({ isModalOpen, handleSaveProductdata, newProduct, customer_name, setNewProduct, onQuoteCreated, handleModalClose, productOptions, isOrder, fetchQuoteDetails, customerId, quote_id, customer_id, quoteNo, isQuoteCreated, setIsQuoteCreated, addOrderForSuit }) => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [searchCustomerId, setSearchCustomerId] = useState("");
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [originalCustomerId, setOriginalCustomerId] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isAddCustomerModalOpen, setIsAddCustomerModalOpen] = useState(false);
  const isEditMode = Boolean(newProduct?._id);
  const { order_id, invoice_id } = useParams();

  const handleCustomerListClick = () => {
    setIsAddCustomerModalOpen(true); // Open popup instead of navigating
  };

  const productCustomerId = newProduct?.customerInfo?.customer_id || newProduct?.customer_id

  const fetchCustomers = async (query = {}) => {
    try {
      const queryParams = new URLSearchParams(query).toString();
      const response = await fetch(`${config.BASE_URL}/api/v1/list?${queryParams}`);
      if (!response.ok) {
        throw new Error("Failed to fetch customers");
      }
      const data = await response.json();
      // console.log('data', data.data)
      setCustomers(data.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isModalOpen) return;

    setOriginalCustomerId(newProduct?.customerInfo?._id || newProduct?.customer_id);
    // ✅ Edit mode → show existing customer
    if (isEditMode && newProduct) {

      setSearchName(newProduct?.customerName || newProduct?.customerInfo?.customer_name);
    }

    // // ✅ New product → empty field
    // if (!isEditMode) {
    //   setSearchName("");
    //   setNewProduct((prev) => ({ ...prev, customer_id: "" }));
    // }

    if (!isEditMode) {
      const id = customerId || customer_id;

      setNewProduct((prev) => ({
        ...prev,
        customer_id: id,
        quantity: 1,
      }));

      setSearchName(
        customer_name ||
        ""
      );
    }

  }, [isModalOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.customer_search_reaults') && !event.target.closest('#customer-name')) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);




  const handleSearch = (field, value) => {
    setSearchName(value);

    if (debounceTimeout) clearTimeout(debounceTimeout);

    const newTimeout = setTimeout(() => {
      const query = {};
      if (value) query.customer_name = value;
      fetchCustomers(query);
    }, 300);

    setDebounceTimeout(newTimeout);
  };


  useEffect(() => {
    fetchCustomers();
  }, []);



  const navigate = useNavigate();

  const handleCustomerCreated = (newCustomer) => {
    setSearchName(newCustomer.customer_name);
    setNewProduct((prev) => ({
      ...prev,
      customer_id: newCustomer._id,
      customerName: newCustomer.customer_name,
    }));
    setDropdownOpen(false);
    setIsAddCustomerModalOpen(false); // Close the popup
  };

  const handleProductChange = (key, value) => {
    setNewProduct((prev) => ({ ...prev, [key]: value }));
  };


  const handleSaveProducts = async () => {
    setLoading(true);
    setError(null);

    // 1. Get the correct Customer ID
    const activeCustomerId = newProduct?.customer_id?._id || newProduct?.customer_id || customerId || customer_id;

    if (!activeCustomerId) {
      toast.error("Please select a customer");
      setLoading(false);
      return;
    }

    const selectedStyle = newProduct?.description;
    const isValidProduct = productOptions.some(product => product.style === selectedStyle);

    if (!selectedStyle || !isValidProduct) {
      setError("*Please select a product from the list.");
      toast.error("Please select a product");
      setLoading(false);
      return;
    }

      if (newProduct.quantity === "" || newProduct.quantity === null || newProduct.quantity === undefined) {
    toast.error("Please enter quantity");
     setLoading(false);
    return;
}

    try {
      let addPro = { ...newProduct };
      addPro["customer_id"] = activeCustomerId;
      addPro["customerName"] = searchName;
      addPro["customer_name"] = searchName;

      // ==========================================
      // 🚀 2. ID LOGIC: (Quote, Order, ya Invoice?)
      // ==========================================
      if (isOrder || order_id) {
        // ✅ Agar Order page par hain
        addPro["order_id"] = newProduct.order_id || order_id;
        addPro["quote_id"] = null;
        addPro["invoice_id"] = null;
      }
      else if (window.location.pathname.includes("invoice") || invoice_id) {
        // ✅ Agar Invoice page par hain
        addPro["invoice_id"] = newProduct.invoice_id || invoice_id;
        addPro["quote_id"] = null;
        addPro["order_id"] = null;
      }
      else {
        // ✅ Agar Quote page par hain
        let currentQuoteId = quote_id;

        // Agar naya Quote hai jo abhi DB me nahi bana, toh pehle wo banayenge
        if (!currentQuoteId) {
          const quoteData = { customer_id: activeCustomerId, quoteNo: quoteNo };
          const addQuoteResponse = await axios.post(`${config.BASE_URL}/api/v1/addQuote`, quoteData);

          if (addQuoteResponse.status === 201) {
            currentQuoteId = addQuoteResponse.data.quote._id;
            if (onQuoteCreated) onQuoteCreated(currentQuoteId);
            if (setIsQuoteCreated) setIsQuoteCreated(true);
          } else {
            throw new Error("Failed to create quote base.");
          }
        }

        addPro["quote_id"] = currentQuoteId;
        addPro["order_id"] = null;
        addPro["invoice_id"] = null;
        addPro["quoteNo"] = quoteNo;
      }

      // ==========================================
      // 🧹 3. SANITIZE PAYLOAD (Edit mode ke liye)
      // ==========================================
      if (isEditMode) {
        const fieldsToProtect = ['measurements', 'styles', 'images'];
        fieldsToProtect.forEach(field => {
          const val = addPro[field];
          if ((val && Object.keys(val).length === 0 && !Array.isArray(val)) || (Array.isArray(val) && val.length === 0)) {
            delete addPro[field];
          }
        });
      }

      // ==========================================
      // 🌐 4. API CALL (POST for Add, PUT for Edit)
      // ==========================================
      let response;

      if (isEditMode) {
        // Edit ke liye humesha PUT chalega (Apne URL setup ke hisab se theek karein)
        response = await axios.put(`${config.BASE_URL}/api/v1/editProduct`, addPro);
      } else {
        // Naya Product add karne ke liye humesha POST chalna chahiye
        response = await axios.put(`${config.BASE_URL}/api/v1/addProduct`, addPro);
      }

      // ==========================================
      // 🎨 5. UPDATE UI
      // ==========================================
      if (response.status === 200 || response.status === 201) {
        const { product, products } = response.data;

        // Handle Suit Split (Jacket/Pant)
        if (products && Array.isArray(products)) {
          products?.forEach((p) => handleSaveProductdata?.(p));
          toast.success(isEditMode ? "Suit updated!" : "Suit added successfully!");
        } else if (product) {
          handleSaveProductdata?.(product);
          toast.success(isEditMode ? "Product updated!" : "Product added!");
        }

        if (fetchQuoteDetails) await fetchQuoteDetails();
        handleModalClose();
      }
    } catch (err) {
      console.error('Save Flow Error:', err);
      toast.error(err.response?.data?.message || "Error saving product");
    } finally {
      setLoading(false);
    }
  };


  if (!isModalOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="popup_header">
          <h4>Product Details</h4>
          <button type="button" onClick={handleModalClose} aria-label="Close Modal">
            ×
          </button>
        </div>
        <form>

          {isOrder && <div className="form-group">

            <label htmlFor="customer-name">Select Customer</label>

            <input
              id="customer-name"
              type="text"
              placeholder="Search customer..."
              value={searchName}
              onChange={(e) => {
                setSearchName(e.target.value);
                handleSearch('name', e.target.value);
                setDropdownOpen(true);
              }}
              onFocus={() => setDropdownOpen(true)}
              autoComplete="off"
            />
            {dropdownOpen && searchName && customers.length > 0 && (
              <div className="customer_search_reaults">
                <h6 className='add_customer_table'
                  onClick={() => handleCustomerListClick()}
                ><span>+</span> Add New</h6>
                <table className="table order-table">
                  <tbody>
                    {customers.map((customer) => (
                      <tr
                        key={customer._id}
                        onClick={() => {
                          setSearchName(customer.customer_name);

                          setNewProduct((prev) => ({
                            ...prev,
                            customer_id: customer._id,
                            customerName: customer.customer_name,
                          }));

                          setDropdownOpen(false);
                        }}

                      >
                        <td>{customer.customer_name}</td>
                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>
            )}
          </div>
          }


          <div className="form-group">
            <label htmlFor="product-name">Select Product</label>
            <select
              id="product-name"
              value={newProduct?.description || ""}
              onChange={(e) => handleProductChange("description", e.target.value)}
            >
              <option value="" disabled>Select a product</option>
              {productOptions.map((product) => (
                <option key={product.id} value={product.style}>
                  {product.style}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="quantity">Quantity</label>
            <input
              id="quantity"
              type="number"
              min="1"
              value={newProduct?.quantity ?? ""}
              onChange={(e) => {
                const value = e.target.value;

                if (value === "") {
                  handleProductChange("quantity", "");
                } else {
                  handleProductChange("quantity", parseInt(value));
                }
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="fabric">Select Fabric</label>
            <input
              id="fabric"
              type="text"
              value={newProduct?.fabric}
              onChange={(e) => handleProductChange("fabric", e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="lining">Select Lining</label>
            <input
              id="lining"
              type="text"
              value={newProduct?.lining}
              onChange={(e) => handleProductChange("lining", e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="groomsman">Groomsman</label>
            <div className="input_field">
              <input
                id="groomsman"
                type="checkbox"
                checked={newProduct?.groomsman === true || newProduct?.groomsman === "true"}
                onChange={(e) => handleProductChange("groomsman", e.target.checked)}
              />
              <span className="checked_icon">
                <CheckIcon />
              </span>
              <p>Yes</p>
            </div>
          </div>
          {!isOrder && <div className="form-group">
            <label htmlFor="price">Price</label>
            <input
              id="price"
              type="number"
              min="0"
              value={newProduct?.price === 0 ? "" : newProduct?.price}
              onChange={(e) => {
                const value = e.target.value === "" ? "" : parseFloat(e.target.value);
                handleProductChange("price", value);
              }}
            />  </div>}
          {/* <div className="form-group">
            <label htmlFor="price">Price</label>
            <input
              id="price"
              type="number"
              min="0"
              value={newProduct?.price === 0 ? "" : newProduct?.price}
              onChange={(e) => {
                const value = e.target.value === "" ? "" : parseFloat(e.target.value);
                handleProductChange("price", value);
              }}
            />

          </div> */}
          <div className="form-group">
            <label htmlFor="remarks">Remarks</label>
            <textarea
              id="remarks"
              value={newProduct?.remarks}
              onChange={(e) => handleProductChange("remarks", e.target.value)}
            />
          </div>
          {error && <p style={{ color: "red" }} className="error">{error}</p>}
          <div className="form_footer">
            <button
              type="button"
              onClick={handleSaveProducts}
              className="btn"
            >
              {loading ? 'Saving...' : 'Save Product'}
            </button>
          </div>
        </form>
      </div>
      <AddCustomerFormModal
        isOpen={isAddCustomerModalOpen}
        onClose={() => setIsAddCustomerModalOpen(false)}
        onCustomerCreated={handleCustomerCreated}
      />

    </div>
  )
};

export default AddProductModal;
